<span class="footnote">
  {{ 'cafler-service-description' | translate }}
</span>
